import React from 'react';
import { ESTADOS_SOPORTE } from '../../constants';

function SoportePanel({
  datosCliente,
  soporteActual,
  actualizarSoporteLocal,
  guardarEstadoOperativo,
  guardandoEstado,
  conversacionActiva,
  currentPermissions,
  diagnosticoBCM,
  ejecutandoAccionBCM,
  mensajeBCM,
  ejecutarDiagnostico,
  reiniciarONU,
  verificarReinicioManual,
  desbloquearBCM,
  confirmarSoporte,
  estado,
  svcColor,
  svcBg,
}) {
  const fmt = (value, fallback = '-') => {
    if (value === null || value === undefined) return fallback;
    const text = String(value).trim();
    return text || fallback;
  };

  const fmtDate = (value) => {
    if (!value) return '-';
    try {
      const d = new Date(value);
      if (isNaN(d.getTime())) return String(value);
      return d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return String(value);
    }
  };

  const bcmClass = mensajeBCM
    ? mensajeBCM.startsWith('❌')
      ? 'error'
      : mensajeBCM.startsWith('⚠️')
      ? 'warn'
      : 'success'
    : '';

  // ─── Dirección completa ───
  const buildDireccion = () => {
    if (!datosCliente) return '-';
    const parts = [datosCliente.direccion];
    if (datosCliente.entre_calles_1 || datosCliente.entre_calles_2) {
      const entres = [datosCliente.entre_calles_1, datosCliente.entre_calles_2].filter(Boolean).join(' y ');
      if (entres) parts.push(`(entre ${entres})`);
    }
    if (datosCliente.ciudad) parts.push(`- ${datosCliente.ciudad}`);
    const result = parts.filter(Boolean).join(' ');
    return result || '-';
  };

  return (
    <>
      {/* ─── Estado técnico ─── */}
      <div className="ctx-card">
        <div className="ctx-card-header">
          <span className="ctx-card-title">Estado técnico</span>
          {guardandoEstado && <span style={{ fontSize: 11, color: 'var(--muted)' }}>guardando...</span>}
        </div>
        {soporteActual ? (
          <div className="ctx-details">
            <div style={{ marginBottom: 8 }}>
              <span className="ctx-label">Estado técnico:</span>
              <select
                className="form-select"
                style={{ width: '100%', marginTop: 6 }}
                value={soporteActual.estadoTecnico}
                onChange={async (e) => {
                  actualizarSoporteLocal(conversacionActiva.id, { estadoTecnico: e.target.value });
                  await guardarEstadoOperativo({
                    area: 'soporte',
                    campo: 'estado_soporte',
                    valor: e.target.value,
                    proxima_accion: soporteActual.proximaAccion,
                    visita_tecnica: soporteActual.visitaTecnica === 'Sí',
                    observacion: soporteActual.observacion || null,
                  });
                }}
              >
                {ESTADOS_SOPORTE.map((e) => (
                  <option key={e} value={e}>{e}</option>
                ))}
              </select>
            </div>
            <div style={{ marginBottom: 8 }}>
              <span className="ctx-label">Diagnóstico:</span>
              <input
                className="form-input"
                style={{ width: '100%', marginTop: 6 }}
                value={soporteActual.diagnostico}
                onChange={(e) => actualizarSoporteLocal(conversacionActiva.id, { diagnostico: e.target.value })}
              />
            </div>
            <div>
              <span className="ctx-label">Observación:</span>
              <textarea
                className="form-input"
                style={{ width: '100%', marginTop: 6, minHeight: 70, resize: 'vertical' }}
                value={soporteActual.observacion}
                onChange={(e) => actualizarSoporteLocal(conversacionActiva.id, { observacion: e.target.value })}
                onBlur={async (e) => {
                  await guardarEstadoOperativo({
                    area: 'soporte',
                    campo: 'estado_soporte',
                    valor: soporteActual.estadoTecnico,
                    proxima_accion: soporteActual.proximaAccion,
                    visita_tecnica: soporteActual.visitaTecnica === 'Sí',
                    observacion: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        ) : (
          <div className="empty-note">Sin estado técnico cargado todavía.</div>
        )}
      </div>

      {/* ─── Diagnóstico ONU (BCM) ─── */}
      {currentPermissions.viewTechnicalData && diagnosticoBCM && (
        <div className="ctx-card">
          <div className="ctx-card-header">
            <span className="ctx-card-title">Diagnóstico ONU (BCM)</span>
            <span
              className="status-badge"
              style={{
                background: diagnosticoBCM.estado_onu === 0 ? '#ef444422' : '#22c55e22',
                color: diagnosticoBCM.estado_onu === 0 ? '#ef4444' : '#4ade80',
                fontSize: 11,
              }}
            >
              {diagnosticoBCM.estado_onu === 0 ? 'Sin potencia' : 'Online'}
            </span>
          </div>
          <div className="tech-grid">
            {diagnosticoBCM.serial && (
              <div className="tech-item">
                <span className="tech-label">Serial ONU</span>
                <span className="tech-val">{diagnosticoBCM.serial}</span>
              </div>
            )}
            {diagnosticoBCM.rx_power && (
              <div className="tech-item">
                <span className="tech-label">RX Power</span>
                <span className="tech-val">{diagnosticoBCM.rx_power} dBm</span>
              </div>
            )}
            {diagnosticoBCM.ssid_2g && (
              <div className="tech-item">
                <span className="tech-label">SSID 2.4GHz</span>
                <span className="tech-val">{diagnosticoBCM.ssid_2g}</span>
              </div>
            )}
            {diagnosticoBCM.ssid_5g && (
              <div className="tech-item">
                <span className="tech-label">SSID 5GHz</span>
                <span className="tech-val">{diagnosticoBCM.ssid_5g}</span>
              </div>
            )}
            {diagnosticoBCM.diagnostico_resumen && (
              <div style={{ gridColumn: '1/-1', marginTop: 4 }}>
                <span className="tech-label">Resumen</span>
                <div style={{ fontSize: 12, color: 'var(--muted-2)', lineHeight: 1.5, marginTop: 2 }}>
                  {diagnosticoBCM.diagnostico_resumen}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── Estado del servicio ─── */}
      {datosCliente && (
        <div className="ctx-card">
          <div className="ctx-card-header">
            <span className="ctx-card-title">Estado del servicio</span>
            <span className="status-badge" style={{ background: svcBg, color: svcColor, fontSize: 11 }}>
              {estado}
            </span>
          </div>
          <div className="ctx-details">
            <div className="ctx-row">
              <span className="ctx-label">Servicio</span>
              <span className="ctx-value" style={{ color: svcColor }}>{estado}</span>
            </div>
            <div className="ctx-row">
              <span className="ctx-label">Estado actual</span>
              <span className="ctx-value">
                {diagnosticoBCM?.diagnostico_resumen || 'Sin fallas reportadas'}
              </span>
            </div>
            <div className="ctx-row">
              <span className="ctx-label">Plan</span>
              <span className="ctx-value">{fmt(datosCliente.plan)}</span>
            </div>
            {datosCliente.precio && (
              <div className="ctx-row">
                <span className="ctx-label">Precio</span>
                <span className="ctx-value">
                  ${parseFloat(datosCliente.precio).toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                </span>
              </div>
            )}
            {(datosCliente.velocidad_down || datosCliente.velocidad_up) && (
              <div className="ctx-row">
                <span className="ctx-label">Velocidad</span>
                <span className="ctx-value">
                  {fmt(datosCliente.velocidad_down)} / {fmt(datosCliente.velocidad_up)} Mbps
                </span>
              </div>
            )}
            <div className="ctx-row">
              <span className="ctx-label">Última conexión</span>
              <span className="ctx-value">
                {datosCliente.ultima_conexion
                  ? fmtDate(datosCliente.ultima_conexion)
                  : (diagnosticoBCM?.ultima_conexion || '-')}
              </span>
            </div>
            <div className="ctx-row">
              <span className="ctx-label">Equipos</span>
              <span className="ctx-value">
                {datosCliente.equipos || diagnosticoBCM?.equipo || '-'}
              </span>
            </div>
            {datosCliente.nodo && (
              <div className="ctx-row">
                <span className="ctx-label">Nodo</span>
                <span className="ctx-value">{fmt(datosCliente.nodo)}</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── Dirección del servicio ─── */}
      {datosCliente && (datosCliente.direccion || datosCliente.ciudad) && (
        <div className="ctx-card">
          <div className="ctx-card-header">
            <span className="ctx-card-title">Dirección del servicio</span>
          </div>
          <div className="address-line">{buildDireccion()}</div>
          {datosCliente.nodo && (
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>
              Nodo: <span style={{ color: 'var(--text)', fontWeight: 500 }}>{datosCliente.nodo}</span>
            </div>
          )}
          {datosCliente.direccion && (
            <button
              className="map-btn"
              onClick={() => {
                const q = encodeURIComponent(
                  [datosCliente.direccion, datosCliente.ciudad].filter(Boolean).join(', ')
                );
                window.open(`https://www.google.com/maps/search/?api=1&query=${q}`, '_blank');
              }}
            >
              📍 Ver en mapa
            </button>
          )}
        </div>
      )}

      {/* ─── Acciones técnicas BCM ─── */}
      {currentPermissions.viewTechnicalData && soporteActual && (
        <div className="ctx-card">
          <div className="ctx-card-header">
            <span className="ctx-card-title">Acciones técnicas BCM</span>
            {ejecutandoAccionBCM && (
              <span style={{ fontSize: 11, color: 'var(--muted)' }}>procesando...</span>
            )}
          </div>
          <button className="service-action" onClick={ejecutarDiagnostico} disabled={ejecutandoAccionBCM}>
            🔍 Diagnóstico ONU
          </button>
          <button className="service-action" onClick={reiniciarONU} disabled={ejecutandoAccionBCM || !diagnosticoBCM?.serial}>
            🔄 Reiniciar ONU
          </button>
          {mensajeBCM && mensajeBCM.includes('Sin reconexión') && (
            <button className="service-action" onClick={verificarReinicioManual}>
              🔍 Verificar ahora
            </button>
          )}
          <button className="service-action" onClick={desbloquearBCM} disabled={ejecutandoAccionBCM}>
            🔓 Desbloquear en BCM
          </button>
          <button
            className="service-action"
            onClick={confirmarSoporte}
            disabled={ejecutandoAccionBCM}
            style={{ color: '#4ade80' }}
          >
            🎫 Generar ticket ISPCube
          </button>
          {mensajeBCM && <div className={`bcm-message ${bcmClass}`}>{mensajeBCM}</div>}
        </div>
      )}
    </>
  );
}

export default React.memo(SoportePanel);
